import { render } from "./FooterPartner.vue?vue&type=template&id=c44829f2&scoped=true&ts=true"
import script from "./FooterPartner.vue?vue&type=script&lang=ts"
export * from "./FooterPartner.vue?vue&type=script&lang=ts"

import "./FooterPartner.vue?vue&type=style&index=0&id=c44829f2&scoped=true&lang=scss"

import exportComponent from "/var/www/html/devcwmserver.com/taca/client/staging/RACA_FRONTEND/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c44829f2"]])

export default __exports__